export type CompanyOption = {
    id: string;
    name: string;
};

export function CompanyOption_normalize(companyOption: CompanyOption): CompanyOption {
    return {
        id: companyOption.id ?? "",
        name: companyOption.name ?? ""
    };
}
